module.exports = __webpack_public_path__ + "img/photo2.3bac5ef8.jpg";